import { initialState } from "../../shared/state/reducer";
import { IADPState, NCSHealthResponse, NetworkConnectionTypes, appPhase } from "../../shared/typings";



export  interface INPNState extends IADPState {
        npnAppState: {
            networkConnection: NetworkConnectionTypes,
            ncsDetails?: NCSHealthResponse,
            ncsHealthURI:  string | undefined,
            classroomServerCode?: string,
          },
        npnFlow:appPhase[],
        initilizeOnlineFlow: boolean,
           
}

export const npnInitialState:INPNState = {
    ...initialState,
    appState: {
        ...initialState.appState,
        launchMode: "NPN",
    },
    sessionState: {
        ...initialState.sessionState,
        selectedAssessmentMode: "ncs",
        appAccessedFor: undefined,
        connectionType: "NPN"
    },
    deviceState: {
        ...initialState.deviceState,
        deviceType: "NPE"
    },
    npnAppState:{
        networkConnection: "Offline",
        ncsHealthURI: undefined
    },
    initilizeOnlineFlow: false,
    npnFlow:[
        {
           
            name: "Initilizing",
            status: "NotStarted"
        },
        {
           
            name: "UpdateSessionDetails",
            status: "NotStarted"
        },
        {
           
            name: "NetworkCheck",
            status: "NotStarted"
        },
        {
           
            name: "UpdateCheck",
            status: "NotStarted"
        },
        {
           
            name: "ModeSelection",
            status: "NotStarted"
        },
        {
           
            name: "CodeVerification",
            status: "NotStarted"
        },
        {
       
            name: "DeviceValidation",
            status: "NotStarted"
        },
        {
  
            name: "TransitionToSCI",
            status: "NotStarted"
        }
    ] 
}